import React from 'react';
import Icon from '../../../components/AppIcon';

const CriticalMetricsCard = ({ title, value, subtitle, icon, color, trend }) => {
  const colorClasses = {
    green: 'bg-green-50 text-green-600',
    yellow: 'bg-yellow-50 text-yellow-600',
    red: 'bg-red-50 text-red-600',
    blue: 'bg-blue-50 text-blue-600'
  };

  const getStatusIndicator = () => {
    if (color === 'green') return { icon: 'CheckCircle', color: 'text-green-600' };
    if (color === 'yellow') return { icon: 'AlertCircle', color: 'text-yellow-600' };
    if (color === 'red') return { icon: 'XCircle', color: 'text-red-600' };
    return { icon: 'Info', color: 'text-blue-600' };
  };

  const statusIndicator = getStatusIndicator();

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-600 mb-2">{title}</p>
          <p className="text-3xl font-bold text-gray-900 mb-1">{value}</p>
          {subtitle && (
            <p className="text-sm text-gray-500">{subtitle}</p>
          )}
          {trend && (
            <div className="mt-3 flex items-center gap-2">
              <Icon name={statusIndicator?.icon} className={`w-4 h-4 ${statusIndicator?.color}`} />
              <span className="text-xs text-gray-600">{trend}</span>
            </div>
          )}
        </div>
        <div className={`p-3 rounded-lg ${colorClasses?.[color] || colorClasses?.blue}`}>
          <Icon name={icon} className="w-6 h-6" />
        </div>
      </div>
    </div>
  );
};

export default CriticalMetricsCard;